import { Upload } from "lucide-react";
import { useState } from "react";

const SingleFileUpload = ({
  type,
  name,
  register,
  errors,
  label,
  defaultValue,
  accept,
  setValue,
}) => {
  const [file, setFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  // Handle file change event
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setValue(name, selectedFile);

    if (selectedFile) {
      setFile({
        name: selectedFile.name,
        size: (selectedFile.size / 1024).toFixed(2), // size in KB
        type: selectedFile.type,
      });
    }

    if (selectedFile) {
      setImagePreview(URL.createObjectURL(selectedFile));
    }
  };

  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="flex items-center justify-center gap-2 mb-1">
        {!file ? (
          <label
            className=" bg-primary/80 text-text-gen p-1 rounded-md cursor-pointer hover:bg-primary"
            htmlFor={name}
          >
            <Upload />
          </label>
        ) : (
          file &&
          accept !== "image/*" && (
            <label
              className=" bg-primary/80 text-text-gen p-1 rounded-md cursor-pointer hover:bg-primary"
              htmlFor={name}
            >
              <Upload />
            </label>
          )
        )}
        {!file && <label className="text-text-1/90 font-medium">{label}</label>}
        <input
          type={type || "file"}
          id={name}
          defaultValue={defaultValue}
          className="hidden"
          accept={accept}
          {...register(name)}
          onChange={handleFileChange}
        />
      </div>

      {errors && <p className="text-red-400 text-xs">{errors.message}</p>}
      {file && (
        <>
          {file && accept !== "image/*" ? (
            <div className="p-3 border border-bkg2 rounded-md mt-2 overflow-hidden">
              <p className="text-sm font-bold mb-1">{file.name}</p>
              <p className="text-sm text-text-1/60">
                <strong>Size:</strong> {file.size} KB
              </p>
              <p className="text-sm text-text-1/60">
                <strong>Type:</strong> {file.type}
              </p>
            </div>
          ) : (
            <div className="border border-bkg2 rounded-md overflow-hidden h-full">
              <label className="block cursor-pointer" htmlFor={name}>
                <img src={imagePreview} alt={file.name} />
              </label>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SingleFileUpload;
